// extracted by mini-css-extract-plugin
export default {"container":"UrlTab_container__U8tsz","deleteButton":"UrlTab_deleteButton__e9ZNg"};